import { useQuery } from "@tanstack/react-query";
import { CalendarCheck, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import LeadForm from "@/components/site/LeadForm";

const POINTS = [
  "A no-pressure conversation about your goals",
  "Honest guidance on scope, timeline and budget",
  "Clear next steps and a tailored proposal",
  "No fabricated promises or guaranteed-ranking claims",
];

export default function Consultation() {
  useSeo({ title: "Book a Consultation", description: "Book a free consultation with Buddy Solution to discuss your project goals and get a tailored plan." });
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data });

  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Book a call" title="Get a free consultation"
        subtitle="Choose a preferred time and tell us about your project. We'll confirm by email and come prepared." /></Reveal>

      <div className="mt-14 grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <div className="h-full rounded-2xl border border-border bg-card/40 p-8">
            <div className="inline-flex rounded-xl bg-accent/12 p-3 text-accent"><CalendarCheck className="h-7 w-7" /></div>
            <h3 className="mt-4 font-display text-2xl font-bold">What to expect</h3>
            <ul className="mt-6 space-y-3">
              {POINTS.map((p) => <li key={p} className="flex items-start gap-3 text-sm"><CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-success" /> {p}</li>)}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
            <LeadForm type="consultation" services={services} showBudget showDate submitLabel="Book my consultation" />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
